// Colores OFICIALES de sucursal (sistema de facturación · Victor 2026-06-11).
// Fuente única para TODOS los filtros de sucursal: chat (vista por sucursal /
// "despliegue") y leads (chips del Kanban). Si cambia un color, se cambia aquí
// y se refleja en todos lados.
//   · Sto. Dgo. Oeste (SDO) → rosa
//   · Sto. Dgo. Este  (SDE) → azul
//   · Santiago        (STG) → verde
//   · La Romana       (ROM) → dorado/tan
//   · Personal              → morado
const BRANCH_COLORS = {
  personal: '#8b5cf6',
  sdo: '#c47d93',
  sde: '#7e9ec7',
  stg: '#7ec79f',
  rom: '#c2a86b',
};

// Alias de nomenclaturas usadas en el código (Kanban usa 'santiago'/'romana').
const ALIAS = { santiago: 'stg', romana: 'rom', lrm: 'rom' };

export function branchColor(key) {
  const k = String(key || '').toLowerCase();
  return BRANCH_COLORS[k] || BRANCH_COLORS[ALIAS[k]] || '#94a3b8';
}

// Por ID de sucursal: SDO=2, SDE=3, Santiago=5, La Romana=4/9, personal=1/6/8.
const BY_ID = {
  2: 'sdo', 3: 'sde', 5: 'stg', 4: 'rom', 9: 'rom', 1: 'personal', 6: 'personal', 8: 'personal',
};
export function branchColorById(id) {
  return branchColor(BY_ID[Number(id)]);
}
